import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type {
  BaseConnectionData,
  WaadConfigData,
} from './EnterpriseConnectionSchema';
import {
  ClientCredentialsFields,
  DomainField,
  LoginExperienceSection,
} from './SharedSsoFormFields';

interface Props {
  isDisabled?: boolean;
}

const AzureAdConfigurationForm: FC<Props> = ({ isDisabled = false }) => {
  const { control } = useFormContext<WaadConfigData>();
  const baseControl = control as unknown as Control<BaseConnectionData>;
  const { t } = useTranslation('common', { keyPrefix: 'sso' });

  return (
    <>
      <DomainField
        control={baseControl}
        isDisabled={isDisabled}
        label={t('domain.azure.label')}
        description={t('domain.azure.description')}
        placeholder={t('domain.azure.placeholder')}
      />

      <ClientCredentialsFields
        control={baseControl}
        isDisabled={isDisabled}
        providerLabel={'Azure AD'}
      />

      <LoginExperienceSection control={baseControl} isDisabled={isDisabled} />
    </>
  );
};

export default AzureAdConfigurationForm;
